module.exports = __webpack_public_path__ + "front/img/logo3.99ca3dc5.png";